import styled from 'styled-components'

export default styled.section`
  margin: 1rem;
`
